import BucketApiRequest from "./BucketApiRequest";
import { GET_INTENDED_USE_URL } from "../ApiUrls";

export default class IntendedUseApiRequest extends BucketApiRequest {
  getUrl = () => {
    return GET_INTENDED_USE_URL;
  };
}
